import { Component } from '@angular/core';
import { NavController, NavParams,ToastController,Platform,AlertController,LoadingController} from 'ionic-angular';
import { NgForm } from '@angular/forms';
import { BluetoothSerial } from '@ionic-native/bluetooth-serial';
import { BluetoothLE } from '@ionic-native/bluetooth-le';
import { PrintProvider } from '../../providers/print/print';

@Component({
  selector: 'page-add-printer',
  templateUrl: 'add-printer.html',
})
export class AddPrinterPage {
  printer:any={}
  type=[]
  size=[]
  submitted=false;
  devices = [];
  flag;
  // testRadioOpen: boolean;

  constructor(public alertCtrl: AlertController,public toastCtrl: ToastController,public bluetoothle: BluetoothLE,public plt: Platform,public bluetoothSerial:BluetoothSerial, public navCtrl: NavController, public navParams: NavParams,public loadingCtrl: LoadingController) {
    this.types()
    this.printer.printer_type = 'Bluetooth Print';
    this.printer.printer_size = '3 inch receipt (80mm)';
    this.bluetoothstatus()
    this.btnFindDevices()
    // this.printer.printer_name = localStorage.Printername;
    // btnBlueToothConnect
  }

  types(){
    this.type = [{id:1,name:'Bluetooth Print'}]
    // this.type = [{id:1,name:'Network Print'},{id:2,name:'Bluetooth Print'},{id:3,name:'Android Print'}]
    this.size = [{id:1,name:'3 inch receipt (80mm)'},{id:2,name:'2 inch receipt (58mm)'},{id:3,name:'A4 size'},{id:3,name:'A5 size'}]
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad AddPrinterPage');
  }

  print_Form(form: NgForm, printer){

  }
  bluetoothstatus(){
  this.plt.ready().then((readySource) => {

    console.log('Platform ready from', readySource);
 
    this.bluetoothle.initialize().then(ble => {
      console.log('ble', ble.status) 
      // logs 'enabled'
      if(ble.status == 'enabled'){
      this.flag = 1
            }
      else{
        this.flag = 0
      }
          });
 
   });
  }

  test_print(){

  }
  bluetoothon(){
    this.bluetoothstatus()
    if(this.flag == 0){
    this.plt.ready().then((readySource) => {
  
      console.log('Platform ready from', readySource);
   
      this.bluetoothle.enable().then(ble => {
        console.log('ble', ble.status) // logs 'enabled'
        this.flag = 1;
        // this.bluetoothstatus()
      });
   
     });
    }
    // else{
      // this.plt.ready().then((readySource) => {
  
        // console.log('Platform ready from', readySource);
     
        // this.bluetoothle.disable()
      
        // .subscribe(ble => {
          // console.log(this.bluetoothle.disable()) // logs 'enabled'
        // });
     
      //  });
    // }
    }
    // showLongToast() {
    //   let toast = this.toastCtrl.create({
    //     message: 'Lorem ipsum doloisicingihicaecati.',
    //     duration: 2000,
    //   });
    //   toast.present();
    // }
    
   
  btnFindDevices(){
    // let loader = this.loadingCtrl.create({
    //   spinner: 'bubbles',
    //   content: 'Loading Please Wait...'
    // });
    // this.bluetoothSerial.isEnabled().then(() => {
    //   this.bluetoothSerial.discoverUnpaired().then((allDevices) => {
    //   if(allDevices != undefined)
    //     this.devices = allDevices;
    //   // this.btnBlueToothConnect();
    //   console.log(allDevices);
    //   loader.present();
    //   setTimeout(() => { 
    //     loader.dismiss();
    //   }, 500);
    //   this.devices_show()
    //   });
    // });
    let loader = this.loadingCtrl.create({
      spinner: 'bubbles',
      content: 'Loading Please Wait...'
    });
    this.bluetoothSerial.isEnabled().then(() => {
      var params={
   
      }
      this.bluetoothSerial.list().then((allDevices) => {
      if(allDevices != undefined)
        this.devices = allDevices;
      // this.btnBlueToothConnect();
      console.log(allDevices);
      loader.present();
      setTimeout(() => { 
        loader.dismiss();
      }, 500);
      this.devices_show()
      });
      // this.bluetoothSerial.discoverUnpaired().then((allDevices) => {
      // if(allDevices != undefined)
      //   this.devices = allDevices;
      // // this.btnBlueToothConnect();
      // console.log(allDevices);
      // loader.present();
      // setTimeout(() => { 
      //   loader.dismiss();
      // }, 500);
      // this.devices_show()
      // });
    });
  }

devices_show(){
  let alert = this.alertCtrl.create();
    alert.setTitle('Bluetooth Devices');
for (let i= 0; i<this.devices.length; i++){
   var j = i;
  

    alert.addInput({
      type: 'radio',
      label: this.devices[j].name,
      value: this.devices[j],
      // checked: true
    });
  }
    alert.addButton('Cancel');
    alert.addButton({
      text: 'OK',
      handler: data => {
        console.log(data)
        this.btnBlueToothConnect(data.address)
        localStorage.Printername = data.name
        this.printer.printer_name = data.name
        // this.testRadioOpen = false;
        // this.testRadioResult = data;
      }
    });
    alert.present();
  }
  









btnBlueToothConnect(datas) {
  console.log(datas)
   if (this.devices.length > 0) {
   //this code connects device which’s position is 0. Change it whatever you 
   //want.
   //  this.bluetoothSerial.connect(this.devices[0].id).subscribe((data) => {
   this.bluetoothSerial.connect(datas).subscribe((data) => {
   console.log(data);
   localStorage.bluetoothid = data;
   alert(data)
   }, (error) => {
   console.log(error);
   });
    }
    else {
      alert('Device List did not genereted yet.')
    console.log('Device List did not genereted yet.');
    }
    }

}



// WEBPACK FOOTER //
// ./src/pages/add-printer/add-printer.ts